import { Divider } from "@forge/common";
import React from "react";

interface DividerProps {
  orientation?: "horizontal" | "vertical";
}

const DividerComponent: React.FC<DividerProps> = ({ orientation = "horizontal" }) => {
  return (
    <Divider
      orientation={orientation}
      data-testid="divider-component"
      subtitle=""
      subtitlePosition="left"
      type="inset"
      variant="full-bleed"
    />
  );
};

export default DividerComponent;